import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import Message from "./ValidationMessage";
import InlineField from "./InlineField";
import { getParticularPreferenceSettings } from "../../../../common/selectors/preference";

class DatePickerMax extends Component {
  render() {
    let {
      intl,
      translation,
      input,
      label,
      minDate = {},
      options = {},
      required,
      disabled,
      isClearable = true,
      displayType,
      dateFormat,
      meta: { touched, error, warning },
    } = this.props;
    if (intl && translation) {
      const labelObj = translation.label;
      if (labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    let date = null;
    const inputValue = input.value;
    let minimumDate = {};

    let showError = touched && error ? "error" : "";

    if (typeof inputValue === "string" && inputValue.length > 0) {
      date = moment(inputValue);
    }
    if (typeof inputValue === "object") {
      date = inputValue;
    }

    if (typeof minDate === "string" && minDate.length > 0) {
      minimumDate = moment(minDate);
    }
    if (typeof minDate === "object") {
      minimumDate = minDate;
    }

    const selected = date && { selected: date };
    input.value = date;

    if (displayType === "inline") {
      return (
        <InlineField
          fieldType="renderPickerMaxField"
          content={date ? intl.formatDate(date) : null}
          label={label}
        />
      );
    }

    return (
      <div className={`${required && "required"} field ${showError}`}>
        <label>{label}</label>
        <DatePicker
          {...input}
          isClearable={isClearable}
          disabled={disabled}
          required={required}
          minDate={minimumDate}
          dateFormat={dateFormat}
          {...selected}
          excludeDates={options.excludeDates}
        />
        <Message show={touched} message={error} />
        <Message show={touched} message={warning} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const dateFormat = (
    getParticularPreferenceSettings(state, 'date_format', ['value']) || {}
  ).value;

  return {
    dateFormat,
  };
};

export const DatePickerMaxField = connect(mapStateToProps)(DatePickerMax);

